import React from "react";
import { FaRegStar, FaStar } from "react-icons/fa";

const WorkshopStars = ({ rating }) => {

  let stars = [];

  for (let i = 0; i < Math.round(rating); i++) {
    stars.push(<FaStar color="#ffce50" />);
  }

  let remainingStars = 5 - Math.round(rating)

  for (let i = 0; i < remainingStars; i++) {
    stars.push(<FaRegStar color="#ffce50" />);
  }

  return (
    <>
      {stars}
    </>
  );
};

export default WorkshopStars;
